import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/Atyrau.png'
import _imports_1 from '@/assets/images/atyrau.jpg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "container-fluid intro" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-7" }, [
      /*#__PURE__*/_createVNode("div", { class: "left-region-image" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_0 })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-5" }, [
      /*#__PURE__*/_createVNode("h2", { class: "right-region-paragraf" }, "Атырауская область"),
      /*#__PURE__*/_createVNode("div", { class: "left-region-text" }, " Местность около Атырау – настоящий кладезь для развития туристической отрасли. Однако иностранные путешественники сюда заезжают нечасто. В регионе более развит внутренний туризм, статистика утверждает, что чаще всего казахстанцы посещают область, чтобы побывать в дельте реки Кигач, где находится самая северная точка цветения лотоса. Не менее популярны туры на Каспийское побережье, а также на уникальное озеро Индер с белоснежными берегами, образованными кристаллами соли. ")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, " Статистика туризма Атырауской области утверждает: не менее популярен этот регион как туристическая дестинация и для местных жителей. ")
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-table" }, [
        /*#__PURE__*/_createVNode("table", { id: "city-table" }, [
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Единовременная вместимость (койко-мест) мест размещения, шт "),
            /*#__PURE__*/_createVNode("td", null, "5146")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, "Заполняемость гостиниц (койко-мест), %"),
            /*#__PURE__*/_createVNode("td", null, "24,5")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по внутреннему туризму (резиденты), чел "),
            /*#__PURE__*/_createVNode("td", null, "175088")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по въездному туризму (нерезиденты). чел "),
            /*#__PURE__*/_createVNode("td", null, "74678")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Природный Туризм")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, " Как утверждает статистика туризма в Атырауской области, чаще всего сюда едут с целью полюбоваться красотами природы. Это уникальный в географическом плане регион. Он расположен в Прикаспийской низменности около низовий Волги. Местность очень напоминает просторы на юге России, потому сюда приезжает немало путешественников-россиян. "),
        /*#__PURE__*/_createVNode("p", null, " К Каспийскому морю чаще едут в его восточную часть – местная береговая линия относительно ровная, есть небольшие песчаные косы – это отличное место для пеших прогулок. Также можно отправиться на лодке на прибрежные острова. Северные берега Каспия менее популярны у туристов – они часто заболочены и покрыты зарослями тростника. "),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Любители живописного природного рельефа могут посетить меловое плато "),
          /*#__PURE__*/_createVNode("strong", null, "Аккегершин"),
          /*#__PURE__*/_createTextVNode(", возвышенность "),
          /*#__PURE__*/_createVNode("strong", null, "Бесшокы"),
          /*#__PURE__*/_createTextVNode(" с огромными карстовыми пещерами, достигающими 150 метров в поперечнике. Перспективное направление – поездки в "),
          /*#__PURE__*/_createVNode("b", null, "Мунайлы-Мола"),
          /*#__PURE__*/_createTextVNode(" – месторождение натурального асфальта. Туристам нравится фотографироваться на фоне гладких черных шаров добытого материала, потому такую фотосессию вполне можно внести в услуги тура. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Оздоровительные Поездки")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, " Статистика туризма в Казахстане много лет показывает высокую популярность лечебно-оздоровительных поездок. В Атырауской области поправить здоровье ездят на озеро Индер, которое наполняется водой из многочисленных подземных соленых источников. Местные лечебные грязи содержат соли калия, брома и бора. ")
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, " Перспективы Туристической Отрасли Региона ")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, " Как развивается туризм в Атырауской области? Несколько лет назад регион столкнулся с дефицитом экскурсоводов, особенно владеющих иностранными языками. Сегодня эта проблема решена: на базе Атырауского государственного университета при содействии областного Историко-краеведческого музея были открыты обучающие курсы для гидов. Регион имеет все предпосылки для развития въездного туризма, главные из которых – общая граница с Российской Федерацией и возможность запуска прямых авиарейсов за границу из местного аэропорта. ")
    ])
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("h2", { class: "section__title" }, "ФОТОГАЛЕРЕЯ")
    ])
  ])
], -1)
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "regio-swiper" }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_1
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adaptive_main_top_line = _resolveComponent("adaptive-main-top-line")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_Downloaded = _resolveComponent("Downloaded")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_adaptive_main_top_line),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_swiper, {
              "slides-per-view": 1,
              "space-between": 40,
              loop: false,
              navigation: "",
              onSwiper: _ctx.onSwiper,
              onSlideChange: _ctx.onSlideChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSwiper", "onSlideChange"])
          ])
        ])
      ])
    ]),
    (!_ctx.downloaded)
      ? (_openBlock(), _createBlock(_component_Downloaded, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}